export const messages = {
    applicationNumbers: (totalApps: string, forecastApps: string) =>
        `${totalApps} of ${forecastApps}`,
}
